/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Pagination metadata
 * @export
 * @interface PaginationMetadata
 */
export interface PaginationMetadata {
    /**
     * Current page number
     * @type {number}
     * @memberof PaginationMetadata
     */
    page?: number;
    /**
     * Page size
     * @type {number}
     * @memberof PaginationMetadata
     */
    pageSize?: number;
    /**
     * Total number of items
     * @type {number}
     * @memberof PaginationMetadata
     */
    total?: number;
    /**
     * Total number of pages
     * @type {number}
     * @memberof PaginationMetadata
     */
    totalPages?: number;
    /**
     * Whether there is a next page
     * @type {boolean}
     * @memberof PaginationMetadata
     */
    hasNext?: boolean;
    /**
     * Whether there is a previous page
     * @type {boolean}
     * @memberof PaginationMetadata
     */
    hasPrevious?: boolean;
}

/**
 * Check if a given object implements the PaginationMetadata interface.
 */
export function instanceOfPaginationMetadata(value: object): value is PaginationMetadata {
    return true;
}

export function PaginationMetadataFromJSON(json: any): PaginationMetadata {
    return PaginationMetadataFromJSONTyped(json, false);
}

export function PaginationMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginationMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'total': json['total'] == null ? undefined : json['total'],
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
        'hasNext': json['hasNext'] == null ? undefined : json['hasNext'],
        'hasPrevious': json['hasPrevious'] == null ? undefined : json['hasPrevious'],
    };
}

export function PaginationMetadataToJSON(json: any): PaginationMetadata {
    return PaginationMetadataToJSONTyped(json, false);
}

export function PaginationMetadataToJSONTyped(value?: PaginationMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'page': value['page'],
        'pageSize': value['pageSize'],
        'total': value['total'],
        'totalPages': value['totalPages'],
        'hasNext': value['hasNext'],
        'hasPrevious': value['hasPrevious'],
    };
}

